import React from "react";
import { NavBar } from "./NavBar";

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="app-root">
      <NavBar />
      <main className="app-main">{children}</main>
    </div>
  );
};
